import { render, staticRenderFns } from "./askTopic.vue?vue&type=template&id=39e286cc&scoped=true"
import script from "./askTopic.vue?vue&type=script&lang=js"
export * from "./askTopic.vue?vue&type=script&lang=js"
import style0 from "./askTopic.vue?vue&type=style&index=0&id=39e286cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e286cc",
  null
  
)

export default component.exports